import { useState } from "react";

const useModal = () => {
    const [isShowing, setIsShowing] = useState(false);

    function toggle(e) {
        if (e) e.preventDefault();
        setIsShowing(!isShowing);
    }

    return {
        isShowing,
        toggle
    };
};

export default useModal;
